module.exports = __webpack_public_path__ + "static/media/Patrimonio.a5fd016b.svg";